const PAGE_SIZE = 8;

export default class ChannelsController {
  constructor(Channel, Broadcast, $rootScope, $scope, $state, $uibModal, $q, $timeout, toaster) {
    'ngInject';

    const { ApiConfig } = $rootScope;

    this.$uibModal = $uibModal;
    this.account = $rootScope.account;
    this.$scope = $scope;
    this.$state = $state;
    this.$q = $q;
    this.$timeout = $timeout;
    this.Channel = Channel;
    this.Broadcast = Broadcast;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.toaster = toaster;
    this.defaultTicketPrice = ApiConfig.ticket.default_price;
    this.minTicketPrice = ApiConfig.ticket.minimum_price;
    this.pageSize = PAGE_SIZE;
    this.videoPortalEnabled = $rootScope.account.extra_features.video_portal;
    this.videoPortalLink = this.videoPortalEnabled
      ? `${BOXCAST_TV_VIDEO_PORTAL_URL}${this.account.id}`
      : null;

    this.loadingPromises = [];

    this.loadSelectedBroadcastsForPage = this.loadSelectedBroadcastsForPage.bind(this);

    var query = $state.params;
    if (query.id) {
      this.selectedChannel = { id: query.id };
    }

    this.loaded = false;
    this.reload()
      .then(() => {
        this.loaded = true;
        // Scroll to the selected channel from querystring
        query.id && this.scrollToChannel(query.id);
      })
      .catch((err) => {
        console.error(err);
        toaster.pop('warning', 'Unable to load channels', 'Please refresh the page to try again');
      });

    $scope.$on('broadcast:edited', () => {
      this.loadSelectedBroadcastsForPage(this.broadcastsPagination.current);
    });
  }

  scrollToChannel(id) {
    const scrollToId = `#channel-card-${id}`;
    this.$timeout(() => {
      $('html, body').animate({ scrollTop: $(scrollToId).offset().top - 90 });
    }, 10);
  }

  markChannelIdAsLive(id) {
    this.channels.forEach((c) => {
      if (c.id == id) {
        c.__isLive = true;
      }
    });
  }

  reload() {
    return this.init().then(() => {
      // Flag LIVE channels
      this.liveBroadcasts.forEach((b) => {
        (b.in_channel_ids || []).forEach((channelId) => {
          this.markChannelIdAsLive(channelId);
        });
      });
    });
  }

  init() {
    const { $q, Broadcast, Channel } = this;

    var selected = (this.selectedChannel || {}).id;

    this.channels = Channel.query({ l: 1000 });

    // Restore selected channel with new object
    var cPromise = this.channels.$promise.then(() => {
      if (selected) {
        this.select(_.find(this.channels, { id: selected }), false);
      }
    });

    // All Live Broadcasts ... to use to see which channels have currently live
    // broadcasts, so we need to get each live broadcast in *show* scope so that we
    // can look into the `broadcast.in_channel_ids`
    this.liveBroadcasts = [];
    var bPromise = $q((resolve, reject) => {
      Broadcast.query(
        { q: 'timeframe:preroll timeframe:current', l: 100 },
        (broadcasts) => {
          $q.all(
            broadcasts.map((b) => {
              var broadcast = Broadcast.get({ id: b.id });
              return broadcast.$promise;
            })
          )
            .then((broadcasts) => {
              this.liveBroadcasts = broadcasts;
              resolve(broadcasts);
            })
            .catch((err) => {
              reject(err);
            });
        },
        (err) => reject(err)
      );
    });

    this.loadingPromises.push(cPromise);
    this.loadingPromises.push(bPromise);

    return $q.all([cPromise, bPromise]);
  }

  select(channel, toggleIfSelected = true) {
    const { Channel, $state } = this;

    // Update URL to make back navigation work
    $state.go(
      'channels',
      { id: channel.id },
      { notify: false, location: 'replace', reloadOnSearch: false }
    );

    // Toggle off if already selected
    if (toggleIfSelected && this.selectedChannelId === channel.id) {
      this.selectedChannelId = null;
      this.selectedChannel = {};
      this.broadcasts = [];
      this.broadcastsPagination = {};
      return;
    }

    this.selectedChannelId = channel.id;
    this.selectedChannel = channel;
    this.loadSelectedBroadcastsForPage(1);

    //this.scrollToChannel(channel.id);
  }

  loadSelectedBroadcastsForPage(p) {
    const { Channel, selectedChannelId, toaster } = this;

    this.loadingBroadcasts = true;
    var query = Channel.getBroadcasts(
      {
        id: selectedChannelId,
        p: Math.max(0, p - 1),
        l: PAGE_SIZE,
        s: '-starts_at',
      },
      (data, headers) => {
        this.broadcasts = data;
        var pagination = JSON.parse(headers('x-pagination'));
        this.broadcastsPagination = {
          current: p,
          total: pagination.total,
          resultMin: PAGE_SIZE * (p - 1) + 1,
          resultMax: PAGE_SIZE * (p - 1) + data.length,
        };
        this.loadingBroadcasts = false;
      },
      (err) => {
        toaster.pop('Unable to load broadcasts. Please refresh the page and try again.');
        this.loadingBroadcasts = false;
      }
    );

    this.loadingPromises.push(query.$promise);
  }

  openChannelModal(channel) {
    const { $uibModal, minTicketPrice, defaultTicketPrice } = this;

    // Create vs. Edit
    channel = channel || { ticket_price: defaultTicketPrice, is_private: false };

    const parentVM = this;

    $uibModal.open({
      template: require('./modal-create-channel.html'),
      resolve: {
        channel: () => channel,
        parentVM: () => parentVM,
        minTicketPrice: () => minTicketPrice,
        defaultTicketPrice: () => defaultTicketPrice,
      },
      controllerAs: 'vm',
      controller: require('./modal-create-channel-controller').default,
      keyboard: false,
      backdrop: 'static',
    });
  }

  openAddBroadcastModal(channel) {
    const { $uibModal, Broadcast } = this;

    $uibModal
      .open({
        template: require('../../directives/recording-source-chooser-browse.html'),
        controller: require('../../directives/recording-source-chooser-browse').default,
        size: 'lg',
        controllerAs: 'vm',
        resolve: {
          options: () => ({
            skipRecordingSourceValidation: true,
            modalTitle: 'Add Broadcast to ' + channel.name,
          }),
        },
      })
      .result.then((broadcast) => {
        console.log('adding broadcast ', broadcast.id, ' to channel ', channel.id);
        var channelIds = broadcast.in_channel_ids || [];
        channelIds.push(channel.id);
        return Broadcast.update({ id: broadcast.id }, { in_channel_ids: channelIds }).$promise;
      })
      .then(() => {
        this.reload();
      });
  }
}



// WEBPACK FOOTER //
// ./app/pages/channels/controller.js